import Vue from 'vue';
import clone from 'clone';
export const setBillingMailingValidatedAddress = (
  state,
  { validatedAddress, status, error }
) => {
  if (validatedAddress && state.applicant.data) {
    Vue.set(
      state.applicant.data,
      'mailingValidatedAddress',
      clone(validatedAddress)
    );
    if (state.applicant.data.mailingValidatedAddress) {
      state.applicant.data.mailingValidatedAddress.status = status;
      state.applicant.data.mailingValidatedAddress.error = error;
    }
  }
};
